import { Alignment, Api, LicenseTester, ModelRow, StringUtil } from "@mcleod/core";
import {
    ClickEvent, Component, DataSourceExecutionEvent, DataSourceValidationEvent, DropdownItem, Snackbar
} from "@mcleod/components";
import { CommonTooltips } from "@mcleod/common";
import { AutogenLayoutViewEdiBilling } from "./autogen/AutogenLayoutViewEdiBilling";
import { EdiBillingUtility } from "./EdiBillingUtility";
import { setBatchCodeTooltip, setPartnerNameQuickInfo, generateTransmissionLogQuickInfo } from "./EdiUtility";

export function getReadyToSendDropdownItems(): DropdownItem[] {
    return [
        new DropdownItem("Y", "Yes"),
        new DropdownItem("N", "No"),
        new DropdownItem("V", "Void")
    ];
}

export class ViewEdiBilling extends AutogenLayoutViewEdiBilling {

    private _newBatch: number = 0;
    private _openedFromSlideout: boolean = false;

    override onLoad(): void {
        this.textReadyToSend.items = getReadyToSendDropdownItems();
        EdiBillingUtility.styleTab(this.tabErrors);
    }
    async corrIndBeforeLookupModelSearch(event) {
        EdiBillingUtility.setupCorrectionIndicatorLookupFilter(event, this.sourceEdiBilling.activeRow);
    }

    /** This is an event handler for the afterExecution event of sourceEdiBilling. */
    async sourceEdiBillingAfterExecution(event) {
        const row = event.data;

        EdiBillingUtility.makeTooltipContent(this.txtCorrectionIndicator, row);
        this.txtCorrectionIndicator.addLookupModelSelectionListener(() => {
            EdiBillingUtility.makeTooltipContent(this.txtCorrectionIndicator, row);
        });

        EdiBillingUtility.makeTooltipContent(this.txtServiceCode, row);

        this.txtServiceCode.addLookupModelSelectionListener(() => {
            EdiBillingUtility.makeTooltipContent(this.txtServiceCode, row);
        });
        generateTransmissionLogQuickInfo(this.textboxTransmitted, this.mainDataSource?.activeRow, false);
        // this.setBatchCodeListeners(row);
        setBatchCodeTooltip(this.txtBatch, row, "I", Alignment.TOP);
        this.panelFuncAck.visible = (row) && !StringUtil.isEmptyString(row.get("func_ack_id")) && !this.openedFromSlideout;

        const hasIntercompany = LicenseTester.testClass("com.tms.client.loadmaster.dsp.PanelOrderIntercompany"); //isIntercompanyEnabled(); TODO replace after PR 270900 is complete?
        this.checkboxIntercompany.visible = hasIntercompany;

        this.setPartnerNameQuickInfo();
    }

    /** This is an event handler for the beforeLookupModelSearch event of txtServiceCode. */
    txtServiceCodeBeforeLookupModelSearch(event) {
        EdiBillingUtility.setupServiceCodeLookupFilter(event, this.sourceEdiBilling.activeRow);
    }

    /** This is an event handler for the afterExecution event of sourceEdiMapError. */
    sourceEdiMapErrorAfterExecution(event: DataSourceExecutionEvent) {
        EdiBillingUtility.handleEdiMapErrorAfterExecution(event, this.tabErrors);
    }

    async onSave() {
        try {
            const row = await this.sourceEdiBilling.post();
            if (this.switchTransmit.checked) {
                await Api.post("lme/datafusion/transmit-edi-bill", { edi_billing_id: this.sourceEdiBilling.activeRow.get("id") }).then(async (response) => {
                    if (response.data.length > 0) {
                        const message = response.data[0].error;
                        if (message) {
                            Snackbar.showWarningSnackbar(message);
                        }
                        else {
                            if (response.data.length > 0 && response.data[0].transmitted_batch != null) {
                                this.newBatch = response.data[0].transmitted_batch;
                            }
                        }
                    }
                }
                );
            }
        }
        catch (error) {
            return;
        }

        this.slideOut();

    }

    setBatchCodeListeners(row: ModelRow<any>) {
        const sourceID = row?.get("id");
        const direction = row?.get("direction");
        const partnerId = row?.get("partner_id");
        const altPartnerId = row?.get("alt_partner_id");

        if (sourceID != null && direction === "O") {
            CommonTooltips.setTooltipContentLayout(
                this.txtBatch, null, "lme/datafusion/EdiBatchHistoryQuickInfoTable", null,
                { "edi_batch_history.transaction_id": sourceID, "edi_batch_history.transaction_type": "I", "partner_id": partnerId, "alt_partner_id": altPartnerId }
            );
            this.txtBatch.tooltipDynamicOptions = { position: Alignment.TOP };
        } else if (sourceID != null && direction === "I") {
            CommonTooltips.setTooltipContentLayout(
                this.txtBatch, null, "lme/datafusion/EdiInboundLogQuickInfoTable", null,
                { "id": sourceID, "direction": direction, "partner_id": partnerId, "alt_partner_id": altPartnerId }
            );
            this.txtBatch.tooltipDynamicOptions = { position: Alignment.TOP };
        }
    }

    private _labelTransStatusOnDataDisplay() {
        generateTransmissionLogQuickInfo(this.textboxTransmitted, this.mainDataSource?.activeRow, false);
    }

    private generateTransmissionLogQuickInfo(component: Component, isInbound: boolean) {
        generateTransmissionLogQuickInfo(component, this.mainDataSource?.activeRow, isInbound);
    }

    /** This is an event handler for the onClick event of switchTransmit. */
    switchTransmitOnClick(event: ClickEvent) {
        const textboxes = [
            this.txtShipmentId,
            this.textboxBlnum,
            this.textboxConsigneeRefNo,
            this.textboxCommodity,
            this.textboxCommodityDescr,
            this.textboxWeight,
            this.textboxPieces
        ];

        const isChecked = this.switchTransmit.checked;

        textboxes.forEach(textbox => {
            textbox.enabled = isChecked;
        });
    }

    public get newBatch(): number {
        return this._newBatch;
    }

    public set newBatch(value: number) {
        this._newBatch = value;
    }

    /** This is an event handler for the onValidate event of sourceEdiBilling. */
    sourceEdiBillingOnValidate(event: DataSourceValidationEvent) {
        if (this.sourceEdiBilling.activeRow?.get("batch") > 0) {
            this.sourceEdiBilling.activeRow?.set("batch", 0);
        }
    }

    public get openedFromSlideout(): boolean {
        return this._openedFromSlideout;
    }

    public set openedFromSlideout(value: boolean) {
        this._openedFromSlideout = value;
    }

    setPartnerNameQuickInfo() {
        const row = this.sourceEdiBilling.activeRow;
        setPartnerNameQuickInfo(this.textboxPartnerName, row);
    }
}
